<template>
  <account-modal class="create-account-modal">
    <template slot="heading">Create new account</template>

    <template slot="content">
      <p class="mb-0">You’ll be able to change account name later.</p>

      <v-text-field
        v-model="form.name"
        label="Account name"
        :error-messages="getValidationErrorMessage('name')"
      />
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="!isFormFilled || loading"
        @click="onCreateButtonClick"
      >create</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_CREATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CreateAccountModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        accountCreateApiRequest: new ApiRequest(AccountApi.create),
        form: {
          name: null
        },
        requiredFields: []
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.profileId
      },
      profileLicense () {
        return this.modal.data.profileLicense
      },
      isLegal () {
        return this.modal.data.isLegal
      },
      loading () {
        return this.accountCreateApiRequest.loading
      },
      error () {
        return this.accountCreateApiRequest.error
      }
    },
    created () {
      this.$set(this, 'form', this.formatInitialFormData())
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      formatInitialFormData () {
        return {
          name: null
        }
      },
      onCreateButtonClick () {
        this.accountCreateApiRequest
          .execute(this.profileId, this.form)
          .then(this.accountCreateSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      accountCreateSuccessHandler () {
        this.$eventHub.$emit(EVENT_ACCOUNT_CREATE, this.profileId)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account has been successfully created.' }
          })
        }, 100)
      }
    }
  }
</script>
